/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { styled } from 'fierry/react';

import * as Hexagon from 'solis/type/point/hexagon';

import Svg from 'solis/react/element/icon.svg';


const getPolygonPoints = () =>
{
  const callback = ({ x, y }) => `${x},${y}`;

  return Hexagon.getPoints(Svg.size / 2).map(callback).join(' ');
};


const Outline = styled.polygon`
  fill: none;
  stroke: var(--icon-stroke-normal);
  stroke-width: 1;
`;


const Value = styled.text`
  font-size: 10px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  fill: var(--icon-stroke-text);
  text-anchor: middle;
  dominant-baseline: central;
`;


export default ({ value, size }) =>
(
  <Svg size = {size}>
    <Outline points = {getPolygonPoints()} />
    <Value>{value}</Value>
  </Svg>
);
